import {
  LinkOutlined,
  WarningAmberOutlined,
  CloseOutlined,
  HistoryOutlined,
} from "@mui/icons-material";

export const SALES_ORDER_REGISTER_TITLE = "Sales Order (SO) Register";

export const MAX_UPLOAD_SIZE_MB = 5;
export const ACCEPTED_UPLOAD_FILE_TYPES = ".csv,.xlsx";

export const UPLOAD_TYPE = {
  ORDER_DATA: "ORDER_DATA",
  FG_READINESS: "FG_READINESS",
};

// endpoint - these are NOT interchangeable across sections.
export const UPLOAD_SECTIONS = [
  {
    key: UPLOAD_TYPE.ORDER_DATA,
    title: "Order data",
    description:
      "SAP SO, seller, buyer, material & order qty. New SOs are created; existing SOs are updated.",
    icon: "file",
    uploadUrl: "/fileengine/bulk/file/upload",
    actionType: "PLANT_SUPPLY_FG",
    templateUrl: "/fileengine/bulk/file/template/download",
    templateFileName: "order-data-template.xlsx",
    isDisabled: false,
  },
  {
    key: UPLOAD_TYPE.FG_READINESS,
    title: "FG readiness data",
    description:
      "FG ready / expected qty per SAP SO + material. Updates readiness on matched order lines.",
    icon: "check",
    uploadUrl: "/fileengine/bulk/file/upload",
    actionType: "CFG",
    templateUrl: "/fileengine/bulk/file/template/download",
    templateFileName: "fg-readiness-template.xlsx",
    isDisabled: false,
  },
];

export const UPLOAD_MODAL_TITLE = "Upload data";
export const UPLOAD_MODAL_SUBTITLE = {
  prefix: "Updates the ",
  highlight1: "Sales Order (SO) Register",
  middle: " first, then ",
  highlight2: "FG Tracking",
  suffix: " in real time.",
};

export const UPLOAD_FOOTER_NOTE =
  "Accepted: .csv (recommended) and .xlsx. Match key: SAP SO No. + Material Code. FG uploads require the order to exist first.";

export const SO_BOARD_SORT_OPTIONS = [
  { value: "TONNAGE", label: "Tonnage Due" },
  { value: "FG_READINESS", label: "FG Readiness" },
  { value: "OPEN_ORDERS", label: "Open Orders" },
  { value: "ON_HOLD", label: "On Hold" },
];

export const DEFAULT_SELLER_SORT = {
  sortBy: "TONNAGE",
  sortDir: "ASC",
};

export const EMPTY_SO_BOARD_DATA = {
  pagination: {},
  data: [],
};

export const SO_DASHBOARD_TABLE_FILTERS = [
  {
    key: "UNMAPPED",
    label: "Unmapped SOs",
    countKey: "unmappedso",
    icon: LinkOutlined,
  },
  {
    key: "ABANDONED",
    label: "Abandoned SOs",
    countKey: "abandonedso",
    icon: WarningAmberOutlined,
  },
  {
    key: "TERMINAL_ORDERS",
    label: "SOs mapped with terminal orders",
    countKey: "terminalorderso",
    icon: CloseOutlined,
  },
  {
    key: "HISTORICAL",
    label: "Historical SOs",
    countKey: "historicalso",
    icon: HistoryOutlined,
  },
];

export const SO_LINE_ITEM_COLUMNS = [
  "Seller SKU+Description",
  "OL Ref",
  "Material ID (JSW One)+description",
  "Order Qty",
  "FG Ready (Qty)",
  "Seller update awaited",
  "Rate",
];

export const SO_TABLE_COLUMNS = [
  "",
  "Payer Code",
  "Supplier / Source Seller",
  "Vendor Location",
  "SO Number",
  "Mapped Order",
  "SO Type",
  "Buyer Name",
  "Ship To",
  "Ordered Qty (MT)",
  "Invoiced Qty (MT)",
  "FG Ready Qty",
  "Seller Update Awaited (MT)",
  "Status",
  "Net Landed Value (₹)",
  "Payment Mode",
  "Actions",
];

export const JOPL = "Jsw One Platforms Limited";

export const JODL = "Jsw One Distribution Limited";

export const PAYER_CODE_LABELS = {
  "Jsw One Platforms Limited": "JOPL",
  "Jsw One Distribution Limited": "JODL",
};

export const SO_BOARD_LABELS = {
  closed: "CLOSED",
  noLineItems: "No line items found for this order.",
  mapped: "MAPPED",
};

export const CLOSURE_TYPE = {
  AUTO: "auto",
  MANUAL: "manual",
};
